var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"block":_vm.block,"disabled":_vm.disabled,"variant":_vm.variant}},[_c('b-spinner',{attrs:{"small":""}}),_vm._v(" Loading... ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }